import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/vk': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M545 117.7C548.7 105.2 545 96 527.2 96H468.3C453.3 96 446.4 103.9 442.7 112.7 442.7 112.7 412.7 185.8 370.3 233.2 356.6 246.9 350.3 251.3 342.8 251.3 339.1 251.3 333.4 246.9 333.4 234.4V117.7C333.4 102.7 329.2 96 316.8 96H224.2C214.8 96 209.2 103 209.2 109.5 209.2 123.7 230.4 127 232.6 167V253.8C232.6 272.8 229.2 276.3 221.7 276.3 201.7 276.3 153.1 202.9 124.3 118.9 118.5 102.6 112.8 96 97.7 96H38.8C22 96 18.6 103.9 18.6 112.7 18.6 128.3 38.6 205.8 111.7 308.2 160.4 378.1 229 416 291.4 416 328.9 416 333.5 407.6 333.5 393.1 333.5 326.3 330.1 320 348.9 320 357.6 320 372.6 324.4 407.6 358.1 447.6 398.1 454.2 416 476.6 416H535.5C552.3 416 560.8 407.6 555.9 391 544.7 356.1 469 284.3 465.6 279.5 456.9 268.3 459.4 263.3 465.6 253.3 465.7 253.2 537.6 152 545 117.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/vk.js
// module id = JjOD
// module chunks = 144